import React, { PropsWithChildren, FC } from 'react';

export interface Props {
    direction: 'vertical' | 'horizontal';
    size: number;
}

export const Spacer: FC<PropsWithChildren<Props>> = (
    props: PropsWithChildren<Props>
) => {
    const { direction, size } = props;
    const space = `${size.toString()}px`;
    const width = direction === 'horizontal' ? space : 'unset';
    const height = direction === 'vertical' ? space : 'unset';
    return (
        <div style={{width, height}} />
    );
};
